export default function measurementUnitToggle() {
    return {
        toggle() {
            this.$store.measurementUnit.toggle();
        },
    };
}
